import { faWandMagicSparkles } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Loading } from '@wfp/react';
import type { FC } from 'react';
import React from 'react';
import { useDispatch } from 'react-redux';

import { generateDraftRequest } from 'src/redux/aiNarrative/slice';
import { AiNarrativeContext } from 'src/redux/aiNarrative/types';
import { sendGAEvent } from 'src/utils';

interface Props {
  narrativeId: number;
  currentContent: string;
  context: AiNarrativeContext;
  isLoading: boolean;
  disabled: boolean;
}

const GenerateDraftButton: FC<Props> = ({
  narrativeId,
  currentContent,
  context,
  isLoading,
  disabled,
}) => {
  const dispatch = useDispatch();

  function handleClick() {
    sendGAEvent('ai_generate_draft_btn_clicked');
    dispatch(generateDraftRequest({ narrativeId, currentContent, context }));
  }

  return (
    <Button
      onClick={handleClick}
      kind="ghost"
      className="ai-action-button"
      disabled={disabled || isLoading}
      data-test-id="ai-generate-draft-button"
    >
      {isLoading ? (
        <>
          <Loading className="wfp--loading--small" withOverlay={false} active />
          Generating...
        </>
      ) : (
        <>
          <FontAwesomeIcon icon={faWandMagicSparkles} aria-hidden="true" />
          Generate draft
        </>
      )}
    </Button>
  );
};

export default GenerateDraftButton;
